import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import imgUrl from '@/assets/others/index/bg.gif';
import { setMapTile } from '@/utils/util.js';
var rangingTool;
var map;
var htmlContent;
var mouseTool;
var placeSearch;
import tab from '@/views/dashboard/com/tenant/yesep/testTab.vue';
import jxTab from '@/views/dashboard/com/tenant/jx/testTab.vue';
import { querySiteBySt, queryBigDataById, queryWastDateList, queryWastWaterDateList, queryRealWaterDateList, queryDateSkylist, queryDateSkyRealTime, queryStandardTreeList, queryStand, querySkyStandBySite, queryWasteStand, queryWastegasStand, queryWastesoilStand, querySkyPie, queryAreaInfo, queryPipeSystem, queryManholeCover } from '@/api/api';
import analysis from '@/components/env-bigData/analysis';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { commonRender } from '@/mixins/commonRender';
import mapLegend from "./com/mapLegend1.vue";
import moment from 'moment';
export default {
  components: {
    analysis: analysis,
    tab: tab,
    jxTab: jxTab,
    mapLegend: mapLegend
  },
  mixins: [GetSiteIdMixin, commonRender],
  data: function data() {
    return {
      tenantId: 0,
      showMarkerLabel: false,
      showContent: false,
      infoWindows: [],
      firstState: false,
      selectSt: 'tree',
      searchValue: '',
      state: false,
      location: '',
      adcode: '',
      adname: '',
      showContens: false,
      showTab: false,
      value: '',
      showClose: false,
      showState: false,
      mesureState: false,
      arr: [],
      plugin: [{
        defaultType: 0,
        showRoad: false,
        showTraffic: false
      }],
      // netSelectindex: 0,
      // roadSelectindex: 0,
      // mapControlindex: 0,
      // mapSelectindex: 0,
      // selectIndex: 21,
      imgUrl: require('@/assets/others/index/bg.gif'),
      wrongUrl: require('@/assets/others/index/wrong.png'),
      map: null,
      showDrawer: false,
      heatmap: null,
      showIt: false,
      standList: [],
      markerList: [],
      showLeft: false,
      siteDetail: {},
      timer: '',
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      },
      wellImg: require('@/assets/others/well.png'),
      pipeImg: require('@/assets/others/pipe.png'),
      standardLists: [],
      tabList: [{
        name: '水质',
        st: 21,
        iconfont: 'icon-shuizhijiance'
      }, {
        name: '空气',
        st: 22,
        iconfont: 'icon-app_icons--'
      }],
      tagList: [{
        name: '卫星',
        st: 1
      }, {
        name: '路网',
        st: 2
      }, {
        name: '路况',
        st: 23
      }],
      pipeList: [],
      wellList: [],
      showMapTag: false,
      standardList: [],
      standShape: '',
      airStandardList: [],
      wasteStandardList: [],
      wasteAirStandardList: [],
      st: ''
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    this.$nextTick(function () {
      setTimeout(function () {
        _this.initMap();
      }, 500);
    });
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
    map && map.destroy();
  },
  created: function created() {
    var _this2 = this;

    // console.log('window', window)
    // let script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.src = "https://webapi.amap.com/maps?v=1.4.15&key=fff9f6d9570cff54e05b6bd3b1639fb0"
    // document.getElementsByTagName('head')[0].appendChild(script)
    this.selectSt = window.localStorage.getItem('treeSt');
    console.log('this.selectSt', this.selectSt);
    window.addEventListener('setItem', function (e) {
      console.log('en', e);

      if (e.key == 'treeSt') {
        _this2.selectSt = window.localStorage.getItem('treeSt');
      }
    });
    this.getStandard();
    this.getStandards();
    this.getPipeSystem();
    this.getManholeCover();
    this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12;
    this.center = window.localStorage.getItem('mapCenter') && window.localStorage.getItem('mapCenter') != 'null' ? window.localStorage.getItem('mapCenter').split(',') : [118.047928, 24.613341], this.getTenant();

    if (window.localStorage.getItem('projectCode')) {
      if (window.localStorage.getItem('projectCode') == 'meitang') {
        this.showMapTag = true;
        this.standardLists = [{
          title: '处理站',
          value: 3,
          icon: 'icon-yiliaofeishui',
          show: true
        }, {
          title: '泵站',
          value: 1,
          icon: 'icon-bengzhan1',
          show: true
        }, {
          title: this.$store.state.projectCode == 'meitang' ? this.title = '化粪池' : '窨井',
          value: 4,
          icon: '',
          img: this.wellImg,
          show: true
        }, {
          title: '管网',
          value: 5,
          icon: '',
          img: this.pipeImg,
          show: true
        }];
      }
    }
  },
  methods: {
    selctTag: function selctTag(index, selectedIndex, id, isOnline, st) {
      if (isOnline) {
        if (st == 21) {
          this.standardList[selectedIndex].children[index].data.show = !this.standardList[selectedIndex].children[index].data.show;
          var state = JSON.parse(JSON.stringify(this.standardList[selectedIndex].children[index].data.show));

          if (parseInt((this.selectIndex - 0) / 10) == 3) {
            this.markerList.forEach(function (item, index) {
              if (item.upStandard == id) {
                item.show = state;
              }
            });
            this.initMarker();
          } else {
            this.markerList.forEach(function (item, index) {
              if (item.currentStandard) {
                if (item.currentStandard.id == id) {
                  item.show = state;
                }
              }
            });
            this.initMarker();
          }
        } else if (st == 22) {
          this.airStandardList[selectedIndex].children[index].data.show = !this.airStandardList[selectedIndex].children[index].data.show;

          var _state = JSON.parse(JSON.stringify(this.airStandardList[selectedIndex].children[index].data.show));

          if (parseInt((this.selectIndex - 0) / 10) == 3) {
            this.markerList.forEach(function (item, index) {
              if (item.upStandard == id) {
                item.show = _state;
              }
            });
          } else {
            this.markerList.forEach(function (item, index) {
              if (item.currentStandard) {
                if (item.currentStandard.id == id) {
                  item.show = _state;
                }
              }
            });
            this.initMarker();
          }
        } else if (st == 31) {
          this.wasteStandardList[selectedIndex].children[index].data.show = !this.wasteStandardList[selectedIndex].children[index].data.show;

          var _state2 = JSON.parse(JSON.stringify(this.wasteStandardList[selectedIndex].children[index].data.show));

          if (parseInt((this.selectIndex - 0) / 10) == 3) {
            this.markerList.forEach(function (item, index) {
              if (item.upStandard == id) {
                item.show = _state2;
              }
            });
          } else {
            this.markerList.forEach(function (item, index) {
              if (item.currentStandard) {
                if (item.currentStandard.id == id) {
                  item.show = _state2;
                }
              }
            });
            this.initMarker();
          }
        } else if (st == 32) {
          this.wasteAirStandardList[selectedIndex].children[index].data.show = !this.wasteAirStandardList[selectedIndex].children[index].data.show;

          var _state3 = JSON.parse(JSON.stringify(this.wasteAirStandardList[selectedIndex].children[index].data.show));

          if (parseInt((this.selectIndex - 0) / 10) == 3) {
            this.markerList.forEach(function (item, index) {
              if (item.upStandard == id) {
                item.show = _state3;
              }
            });
          } else {
            this.markerList.forEach(function (item, index) {
              if (item.currentStandard) {
                if (item.currentStandard.id == id) {
                  item.show = _state3;
                }
              }
            });
            this.initMarker();
          }
        }
      } else {
        this.onlineStateList[index].show = !this.onlineStateList[index].show;

        var _state4 = JSON.parse(JSON.stringify(this.onlineStateList[index].show)); // 预警部分代码


        if (index == 2) {
          this.markerWarnState = !this.markerWarnState;
          this.handleSiteData(this.markerList);
          console.log('markerList', this.markerList); // this.markerList.forEach((item, index) => {
          //   if (item.warnStatus == true) {
          //     item.show = state
          //   }
          // })
        } else {
          this.markerList.forEach(function (item, index) {
            if (item.onlineStatus == id) {
              item.show = _state4;
            }
          });
        }

        this.initMarker();
      }
    },
    selctTag1: function selctTag1(index, item) {
      console.log('item', item);
      console.log('markerList', this.markerList);
      item.show = !item.show;

      switch (item.value) {
        case 4:
          this.wellList.forEach(function (item1, index1) {
            item1.show = item.show;
          });
          map.clearMap();
          this.initMarker();
          this.showWell();
          this.showLine();
          break;

        case 5:
          this.pipeList.forEach(function (item1, index1) {
            item1.show = item.show;
          });
          map.clearMap();
          this.initMarker();
          this.showWell();
          this.showLine();
          break;

        default:
          this.markerList.forEach(function (item1, index1) {
            if (item1.category == item.value) {
              item1.show = item.show;
            }
          });
          map.clearMap();
          this.initMarker();
          this.showWell();
          this.showLine();
          break;
      }
    },
    getTenant: function getTenant() {
      this.tenantId = window.localStorage.getItem('tenant') ? window.localStorage.getItem('tenant') : 0;
    },
    // 获取所有管网数据
    getPipeSystem: function getPipeSystem() {
      var that = this;
      queryPipeSystem({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.pipeList = res.result.records.map(function (item) {
            var pointList = item.coordinate.split(':');
            var lines = pointList.map(function (v) {
              return v.split('-').map(function (item) {
                return item.split(',');
              });
            });
            item.show = true;
            item.lines = lines;
            return item;
          });
          that.showLine();
        }
      });
    },
    // 获取所有窨井盖数据
    getManholeCover: function getManholeCover() {
      var that = this;
      queryManholeCover({
        current: 1,
        size: 1000000
      }).then(function (res) {
        if (res.success && res.result) {
          that.wellList = res.result.records.map(function (item) {
            item.show = true;
            return item;
          });
          that.showWell();
        }
      });
    },
    // 渲染管网
    showLine: function showLine() {
      console.log('this.pipeList1111', this.pipeList);
      this.pipeList.forEach(function (item) {
        if (item.show) {
          item.lines.forEach(function (line) {
            var polyLine = new AMap.Polyline({
              path: line,
              strokeWeight: 5,
              strokeColor: '#55aaff'
            });
            map.add(polyLine);
            var text = new AMap.Marker({
              offset: new AMap.Pixel(-20, -25),
              content: "<span style=\"padding: 5px 10px;background-color: #fff;color: #2eabff;border-radius: 5px;word-break: keep-all;white-space: nowrap\">".concat(item.title, "</span>"),
              position: line[0],
              zIndex: 100000
            });
            map.add(text);
          });
        }
      });
    },
    // 渲染井盖
    showWell: function showWell() {
      var _this3 = this;

      this.wellList.forEach(function (item) {
        if (item.show) {
          item.content = "<img style=\"width: 30px;height: 30px;\" src=\"".concat(_this3.wellImg, "\" />");
          var marker = new AMap.Marker({
            position: new AMap.LngLat(item.coordinate.split(',')[0], item.coordinate.split(',')[1]),
            // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            offset: new AMap.Pixel(-20, -20),
            content: item.content,
            zIndex: 100000
          });
          marker.on('click', function (data) {});
          map.add(marker);
        }
      });
    },
    drawBounds: function drawBounds(areaId) {
      map.clearMap();
      this.initMarker();
      this.showLine();

      if (areaId) {
        queryAreaInfo(areaId).then(function (res) {
          if (res.success) {
            var features = [];

            if (res.result.mapCenter) {
              map.setCenter(JSON.parse(res.result.mapCenter));
            }

            if (res.result.mapStructure) {
              var pointList = JSON.parse(res.result.mapStructure).features.split(':');
              features = pointList.map(function (v) {
                return v.split('-').map(function (item) {
                  return item.split(',');
                });
              });
            }

            if (features.length > 0) {
              // var outer = [
              //   new AMap.LngLat(-360, 90, true),
              //   new AMap.LngLat(-360, -90, true),
              //   new AMap.LngLat(360, -90, true),
              //   new AMap.LngLat(360, 90, true)
              // ]
              // var inline = features.map(area => {
              //   return area.map(info => {
              //     return new AMap.LngLat(info[0], info[1], true)
              //   })
              // })
              // var pathArray = [
              //   outer
              // ]
              // pathArray.push.apply(pathArray, inline)
              // var polygon = new AMap.Polygon({
              //   // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
              //   pathL: pathArray,
              //   //线条颜色，使用16进制颜色代码赋值。默认值为#006600
              //   strokeColor: 'rgb(20,164,173)',
              //   strokeWeight: 4,
              //   //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
              //   strokeOpacity: 0.5,
              //   //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
              //   fillColor: 'rgba(0,0,0)',
              //   //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
              //   fillOpacity: 0.5,
              //   zIndex: 99999999
              // })
              // polygon.setPath(pathArray)
              // map.add(polygon)
              features.forEach(function (area) {
                var polygon = new AMap.Polygon({
                  // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                  path: area,
                  strokeColor: 'rgb(20,164,173)',
                  strokeWeight: 4,
                  //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                  strokeOpacity: 0.5,
                  //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                  fillColor: 'rgba(0,0,0)',
                  //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                  fillOpacity: 0.5,
                  zIndex: 99999999 // strokeColor: '#FF33FF',
                  // strokeWeight: 3,
                  // strokeOpacity: 0.5,
                  // fillOpacity: 0.3,
                  // fillColor: '#1791fc',
                  // zIndex: 99999999

                });
                map.add(polygon);
              });
            }
          }
        });
      } else {
        var areaRoot = window.localStorage.getItem('areaRoot') && window.localStorage.getItem('areaRoot') != 'null' ? window.localStorage.getItem('areaRoot').split(',') : [];
        areaRoot.forEach(function (item) {
          queryAreaInfo(item).then(function (res) {
            if (res.success) {
              var features = [];

              if (res.result.mapCenter) {
                map.setCenter(res.result.mapCenter);
              }

              if (res.result.mapStructure) {
                var pointList = JSON.parse(res.result.mapStructure).features.split(':');
                features = pointList.map(function (v) {
                  return v.split('-').map(function (item) {
                    return item.split(',');
                  });
                });
              }

              if (features.length > 0) {
                var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
                var inline = features.map(function (area) {
                  return area.map(function (info) {
                    return new AMap.LngLat(info[0], info[1], true);
                  });
                });
                var pathArray = [outer];
                pathArray.push.apply(pathArray, inline);
                var polygon = new AMap.Polygon({
                  // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                  pathL: pathArray,
                  //线条颜色，使用16进制颜色代码赋值。默认值为#006600
                  strokeColor: 'rgb(20,164,173)',
                  strokeWeight: 4,
                  //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                  strokeOpacity: 0.5,
                  //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
                  fillColor: 'rgba(0,0,0)',
                  //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
                  fillOpacity: 0.5,
                  zIndex: 99999999
                });
                polygon.setPath(pathArray);
                map.add(polygon); // features.forEach(area=>{
                //   var polygon = new AMap.Polygon({
                //     // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
                //     path: area,
                //     strokeColor: "#FF33FF",
                //     strokeWeight: 3,
                //     strokeOpacity: 0.5,
                //     fillOpacity: 0.3,
                //     fillColor: "#1791fc",
                //     zIndex: 99999999
                //   });
                //   map.add(polygon);
                // })
              }
            }
          });
        });
      }
    },
    close: function close(state) {
      console.log('state', state);
      this.showContent = state;
    },
    submit: function submit() {
      if (this.state) {
        map.setZoom(14);
        map.setCenter(this.location);
      } else {
        placeSearch.setCity(this.adcode);
        placeSearch.search(this.adname);
      }
    },
    ontoClear: function ontoClear() {
      this.showClose = false;
      mouseTool.close(true);
    },
    ontoClose: function ontoClose() {
      this.showClose = false;
      mouseTool.close();
    },
    ontoMesure: function ontoMesure() {
      this.showState = true;
      this.showClose = true;
      mouseTool.rule({
        startMarkerOptions: {
          //可缺省
          icon: new AMap.Icon({
            size: new AMap.Size(19, 31),
            //图标大小
            imageSize: new AMap.Size(19, 31),
            image: 'https://webapi.amap.com/theme/v1.3/markers/b/start.png'
          })
        },
        endMarkerOptions: {
          //可缺省
          icon: new AMap.Icon({
            size: new AMap.Size(19, 31),
            //图标大小
            imageSize: new AMap.Size(19, 31),
            image: 'https://webapi.amap.com/theme/v1.3/markers/b/end.png'
          }),
          offset: new AMap.Pixel(-9, -31)
        },
        midMarkerOptions: {
          //可缺省
          icon: new AMap.Icon({
            size: new AMap.Size(19, 31),
            //图标大小
            imageSize: new AMap.Size(19, 31),
            image: 'https://webapi.amap.com/theme/v1.3/markers/b/mid.png'
          }),
          offset: new AMap.Pixel(-9, -31)
        },
        lineOptions: {
          //可缺省
          strokeStyle: 'solid',
          strokeColor: '#FF33FF',
          strokeOpacity: 1,
          strokeWeight: 2
        } //同 RangingTool 的 自定义 设置，缺省为默认样式

      });
    },
    ontoArea: function ontoArea() {
      this.showState = false;
      this.showClose = true;
      mouseTool.measureArea({
        strokeColor: '#80d8ff',
        fillColor: '#80d8ff',
        fillOpacity: 0.3 //同 Polygon 的 Option 设置

      });
    },
    onShowleft: function onShowleft() {
      var _this4 = this;

      this.showLeft = !this.showLeft;
      setTimeout(function () {
        _this4.showDrawer = !_this4.showDrawer;
      }, 500);
    },
    onShowright: function onShowright() {
      var _this5 = this;

      this.showTab = !this.showTab;
      setTimeout(function () {
        _this5.showContens = !_this5.showContens;
      }, 500);
    },
    // 点击地图下对应的图标
    Ontoselectwater: function Ontoselectwater(index, index1, obj) {
      var _this6 = this;

      if (index == this.standList.length) {
        this.markerList.forEach(function (item, index2) {
          if (!item.currentStandard) {
            if (item.show) _this6.arr[index2].hide();else _this6.arr[index2].show();
            item.show = !item.show;
          }

          return item;
        });
      } else {
        this.standList[index].children[index1].statu = !this.standList[index].children[index1].statu;
        this.markerList.forEach(function (item, index2) {
          if (item.currentStandard) {
            if (item.currentStandard.title == obj.data.title && item.currentStandard.id == obj.data.id) {
              if (item.show) _this6.arr[index2].hide();else _this6.arr[index2].show();
              item.show = !item.show;
            }

            return item;
          }
        });
      }
    },
    turnTosite: function turnTosite(data) {
      this.$emit('siteTurn', true);
    },
    // OntoTab(st) {
    // 	if (this.selectIndex == st) return
    // 	this.selectIndex = st
    // 	this.selectType = st
    // 	this.getSitearr(st)
    // },
    // 获取国标数据
    getStandards: function getStandards(st) {
      var _this7 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          var arr = [];
          res.result.forEach(function (item, index) {
            if (item.label == '国家标准') {
              arr = item.children;
            }
          });

          if (arr != null) {
            arr.forEach(function (item, index) {
              if (item.children != null) {
                item.children.forEach(function (item1, index1) {
                  item1.statu = true;
                  item1.title = item1.title.replace('类', '');

                  if (item.key == 'K1_3') {
                    item1.class = 'map-tag-cir';
                  } else if (item.key == 'K1_2') {
                    item1.class = 'map-tag-rec';
                  }

                  return item1;
                });
              }

              return item;
            });
          }

          _this7.standList = arr;
        }
      });
    },
    // 获取站点数据
    getSitearr: function getSitearr(st) {
      var _this8 = this;

      this.markerList = [];
      var that = this;
      st = st ? st : undefined;
      querySiteBySt({
        st: st
      }).then(function (res) {
        if (res.success) {
          _this8.handleSiteData(res.result);
        }
      });
    },
    handleSiteData: function handleSiteData(markerList) {
      var _this9 = this;

      var that = this;
      markerList.forEach(function (item, index) {
        if (item.longitude != 'NaN') item.position = [item.longitude, item.latitude];else item.position = ['118.04792', '24.61334'];
        item.show = true;
        item.title = item.name;

        if (item.st == 52) {
          var icon = 'icon-yiliaofeishui';
          if (item.category == 1) icon = 'icon-bengzhan1';

          if (item.upStandard || item.onlineStatus) {
            item.content = _this9.getWasteShape('green', '', item.warnStatus, item.onlineStatus, item.name, icon);
            item.zIndex = 10000000;
          } else if (item.upStandard == null) {
            item.content = that.getWasteShape('#ccc', '', item.warnStatus, item.onlineStatus, item.name, icon);
            item.zIndex = 1;
          } else {
            item.content = that.getWasteShape('red', '', item.warnStatus, item.onlineStatus, item.name, icon);
            item.zIndex = 10000;
          }
        } else if (item.st.startsWith('2') || item.st.startsWith('5') || item.st.startsWith('6')) {
          if (item.currentStandard) {
            if (item.st == '21') {
              item.content = _this9.getCir(item.currentStandard.color ? item.currentStandard.color : 'red', item.currentStandard.title.replace('类', ''), item.warnStatus, item.onlineStatus, item.name);
              item.zIndex = 10000;
            } else if (item.st == '22') {
              item.content = _this9.getRec(item.currentStandard.color ? item.currentStandard.color : 'red', item.currentStandard.title.replace('类', ''), item.warnStatus, item.onlineStatus, item.name);
              item.zIndex = 10000;
            } else if (item.st.startsWith('5')) {
              item.content = _this9.getOval(item.currentStandard.color ? item.currentStandard.color : 'red', item.currentStandard.title.replace('类', ''), item.warnStatus, item.onlineStatus);
              item.zIndex = 10000;
            }
          } else {
            var _icon;

            switch (item.st) {
              case '61':
                _icon = 'icon-shuikushuiwenzhan';
                break;
            }

            if (item.st != '22') {
              item.content = that.getnoneRec('#349d4d', item.name, item.warnStatus, item.onlineStatus, _icon);
              item.zIndex = 1;
            } else {
              item.content = _this9.getRec('#349d4d', '无', item.warnStatus, item.onlineStatus, item.name);
              item.zIndex = 1;
            }
          }
        } else if (item.st.startsWith('3')) {
          var _icon2;

          switch (item.st) {
            case '31':
              _icon2 = 'icon-feiqi';
              break;

            case '32':
              _icon2 = 'icon-wushuifeishui';
              break;

            case '35':
              _icon2 = 'icon-turang';
              break;
          }

          if (item.upStandard) {
            item.content = _this9.getWasteShape('green', '', item.warnStatus, item.onlineStatus, item.name, _icon2);
            item.zIndex = 10000000;
          } else if (item.upStandard == null) {
            item.content = that.getWasteShape('#349d4d', '', item.warnStatus, item.onlineStatus, item.name, _icon2);
            item.zIndex = 1;
          } else {
            item.content = that.getWasteShape('red', '', item.warnStatus, item.onlineStatus, item.name, _icon2);
            item.zIndex = 10000;
          }
        }

        return item;
      });
      this.markerList = markerList;
      this.initMarker();
    },
    ontoTurn: function ontoTurn() {
      map.addControl(new AMap.MapType({
        defaultType: 1,
        //0代表默认，1代表卫星
        showTraffic: true
      }));
    },
    getsiteDetail: function getsiteDetail(id, st) {
      var _this10 = this;

      queryBigDataById({
        id: id
      }).then(function (res) {
        if (res.success) {
          res.result.photo = _this10.getImageView(res.result.photo);
          _this10.siteDetail = res.result;
          _this10.$refs.siteDetail.siteDetail = res.result;
        }

        _this10.getDateLists(id, st);
      }).catch(function (e) {
        _this10.getDateLists(id, st);
      });
    },
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var data = record.factor[code] || {
        value: ''
      };

      if (data.status == '2') {
        return '<span  style=\'color:green;padding-left:15px\' class=\'redText\' title=\'原始数据：  ' + (data.raw != null ? data.raw : '一') + '\'>' + (data.value != null ? data.value : '一') + '<div class=\'iconfont icon-xiangxiajiantou\' style=\'float:right;color:green\' ></div></span>';
      } else if (data.status == '3') {
        return '<span style=\'color:red;padding-left:15px\' title=\'原始数据：' + (data.raw != null ? data.raw : '一') + '\'>' + (data.value != null ? data.value : '一') + '<div class=\'iconfont icon-iconset0414\' style=\'float:right;color:red\' ></div></span>';
      } else {
        return '<span title=\'原始数据：' + (data.raw != null ? data.raw : '一') + '\'>' + (data.value != null ? data.value : '一') + '</span>';
      }
    },
    // 获取日期
    getDay: function getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate; // return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
    },
    // 日期格式化
    doHandleMonth: function doHandleMonth(month) {
      var m = month;

      if (month.toString().length == 1) {
        m = '0' + month;
      }

      return m;
    },
    // 获取站点数据
    getDateLists: function getDateLists(id, selectType) {
      var _this11 = this;

      var that = this.$refs.siteDetail;

      if (selectType == 21) {
        queryWastDateList({
          scopeId: id,
          // type: 1,
          st: selectType,
          scope: 1,
          column: 'data_time',
          // stime:this.getDay(0),
          // etime:this.getDay(0),
          order: 'desc'
        }).then(function (res) {
          if (res.success && res.result.records.length > 0) {
            var state;
            var arr = [];
            var obj = {};
            res.result.query.factors.forEach(function (item, index) {
              if (res.result.records[0].factor[item.code]) {
                obj.value = res.result.records[0].factor[item.code].value;

                if (res.result.records[0].factor[item.code].standard) {
                  obj.standTitle = res.result.records[0].factor[item.code].standard.title;
                  obj.standColor = res.result.records[0].factor[item.code].standard.color;
                } else {
                  obj.standTitle = '';
                  obj.standColor = '';
                }

                switch (res.result.records[0].factor[item.code].status) {
                  case 0:
                    state = '无数据';
                    break;

                  case 1:
                    state = '正常';
                    break;

                  case 2:
                    state = '低报';
                    break;

                  case 3:
                    state = '高报';
                    break;

                  case 4:
                    state = '数据异常';
                    break;
                }

                obj.state = state;
                obj.render = _this11.renderCol(item.code, '', res.result.records[0]);
                obj.title = item.title;
                obj.unitName = item.unitName;
                arr.push(obj);
                obj = {};
                state = '';
                return item;
              }
            });

            if (res.result.records.length > 0) {
              _this11.$refs.siteDetail.standState = res.result.records[0].attrs.upStandard;
              _this11.$refs.siteDetail.standLabel = res.result.records[0].attrs.upStandard ? '达标' : '不达标';
              _this11.$refs.siteDetail.standText = res.result.records[0].attrs.currentStandard && res.result.records[0].attrs.currentStandard.title ? res.result.records[0].attrs.currentStandard.title : '';
            } else {
              _this11.$refs.siteDetail.standState = false;
              _this11.$refs.siteDetail.standLabel = '不达标';
              _this11.$refs.siteDetail.standText = '';
            } // let arr = []
            // for(let i =0;i<6;i++){
            // 	res.result.factors.forEach((item)=>{
            // 		arr.push(item)
            // 	})
            // }
            // this.dateLists = arr
            // this.dateLists = res.result.factors


            _this11.$refs.siteDetail.dateLists = arr;
          } else {
            res.result.query.factors.forEach(function (item, index) {
              item.value = '';
              item.standColor = '';
              item.standTitle = '';
              item.state = '';
              item.render = '';
              return item;
            });
            _this11.$refs.siteDetail.standState = false;
            _this11.$refs.siteDetail.standText = '';
            _this11.$refs.siteDetail.standLabel = '';
            _this11.$refs.siteDetail.dateLists = res.result.query.factors;
          }
        });
      } else if (selectType == 22) {
        this.$refs.siteDetail.showBartype = false;
        this.$refs.siteDetail.showInstrument = false;
        this.$refs.siteDetail.showPieChart = false;

        if (this.tenantId == 18) {
          if (id == '205' || id == '206') {
            this.$refs.siteDetail.changeJxBarType(id);
          } else if (id == '209') {
            this.getSkyJxData(id);
          } else {
            this.getSkyRealTimeData(id);
          }
        } else {
          this.getSkyData(id);
        }
      } else if (selectType.startsWith('3')) {
        queryWastDateList({
          scopeId: id,
          type: 1,
          st: selectType,
          scope: 1
        }).then(function (res) {
          if (res.success && res.result.records.length > 0) {
            var state;
            var arr = [];
            var obj = {};
            res.result.query.factors.forEach(function (item, index) {
              if (res.result.records[0].factor[item.code]) {
                obj.value = res.result.records[0].factor[item.code].value; // item.standTitle = res.result.records[0].factor[item.code].standard.title
                // item.standColor = res.result.records[0].factor[item.code].standard.color
                //         if (res.result.records[0].factor[item.code].status == 1) state='合格'
                // else if(res.result.records[0].factor[item.code].status == null) state = ''
                // else state = '不合格'

                if (res.result.records[0].factor[item.code].status == 1) obj.standColor = 'green';else if (res.result.records[0].factor[item.code].status == null) obj.standColor = '';else obj.standColor = 'red';
                obj.state = state;
                obj.title = item.title;
                obj.unitName = item.unitName;
                obj.render = _this11.renderCol(item.code, '', res.result.records[0]);
                obj.flagState = res.result.records[0].factor[item.code]['flag'] ? res.result.records[0].factor[item.code]['flag'].message : '';
                obj.flagCode = res.result.records[0].factor[item.code]['flag'] ? res.result.records[0].factor[item.code]['flag'].code : '';
                state = '';
                arr.push(obj);
                obj = {};
                return item;
              }
            });
            that.standState = res.result.records[0].attrs.upStandard;
            that.standText = res.result.records[0].attrs.upStandard ? '达标' : '不达标';
            that.dateLists = arr;
          } else {
            res.result.query.factors.forEach(function (item, index) {
              item.value = '';
              item.standColor = '';
              item.flagState = '';
              item.flagCode = '';
              item.render = '';
              return item;
            });
            that.standState = false;
            that.standText = '';
            that.dateLists = res.result.query.factors;
          }
        });
      } else if (selectType.startsWith('6')) {
        var param = {
          st: selectType,
          order: 'desc',
          scopeId: id,
          scope: 1,
          searchCount: true
        };
        var url = "/online/st".concat(selectType, "/realtime/");

        if (selectType == 60 && this.siteDetail.category == 2) {
          param = {
            st: selectType,
            stime: moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
            etime: moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss'),
            order: 'desc',
            scopeId: id,
            scope: 1,
            searchCount: true
          };
          url = "online/st".concat(selectType, "/cn2061/");
        }

        getAction(url, param).then(function (res) {
          if (res.success && res.result.records.length > 0) {
            var state;
            var arr = [];
            var obj = {};
            res.result.query.factors.forEach(function (item, index) {
              if (res.result.records[0].factor[item.code]) {
                obj.value = res.result.records[0].factor[item.code].value; // item.standTitle = res.result.records[0].factor[item.code].standard.title
                // item.standColor = res.result.records[0].factor[item.code].standard.color
                //         if (res.result.records[0].factor[item.code].status == 1) state='合格'
                // else if(res.result.records[0].factor[item.code].status == null) state = ''
                // else state = '不合格'

                if (res.result.records[0].factor[item.code].status == 1) obj.standColor = 'green';else if (res.result.records[0].factor[item.code].status == null) obj.standColor = '';else obj.standColor = 'red';
                obj.state = state;
                obj.title = item.title;
                obj.unitName = item.unitName;
                obj.render = _this11.renderCol(item.code, '', res.result.records[0]);
                obj.flagState = res.result.records[0].factor[item.code]['flag'] ? res.result.records[0].factor[item.code]['flag'].message : '';
                obj.flagCode = res.result.records[0].factor[item.code]['flag'] ? res.result.records[0].factor[item.code]['flag'].code : '';
                state = '';
                arr.push(obj);
                obj = {};
                return item;
              }
            });
            that.standState = res.result.records[0].attrs.upStandard;
            that.standText = res.result.records[0].attrs.upStandard ? '达标' : '不达标';
            that.dateLists = arr;
          } else {
            res.result.query.factors.forEach(function (item, index) {
              item.value = '';
              item.standColor = '';
              item.flagState = '';
              item.flagCode = '';
              item.render = '';
              return item;
            });
            that.standState = false;
            that.standText = '';
            that.dateLists = res.result.query.factors;
          }
        });
      } // else if (selectType == 61) {
      //   queryWastDateList({
      //     scopeId: id,
      //     type: 1,
      //     st: selectType,
      //     scope: 1
      //   }).then(res => {
      //     if (res.success) {
      //       this.showReal = false
      //       this.$nextTick(() => {
      //         this.showReal = true
      //         this.$nextTick(() => {
      //           res.result.query.factors.forEach(item => {
      //             switch (item.code) {
      //               case 'b01002':
      //                 this.data1 = item
      //                 break
      //               case 'b02001':
      //                 this.data2 = item
      //                 break
      //               case 'b02002':
      //                 this.data3 = item
      //                 break
      //               case 'b05001':
      //                 this.data4 = item
      //                 break
      //               case 'b03001':
      //                 this.data5 = item
      //                 break
      //               case 'b03003':
      //                 this.data6 = item
      //                 break
      //               case 'b03004':
      //                 this.data7 = item
      //                 break
      //               case 'b03002':
      //                 this.data8 = item
      //                 break
      //             }
      //           })
      //           if (res.result && res.result.records.length > 0) {
      //             let data = res.result.records[0]
      //             this.$refs.siteDetail.bartype2([data.factor['b01002']
      //               .value
      //             ], [
      //               this.data1.title + '(' + this.data1.unitName +
      //               ')'
      //             ])
      //             this.$refs.siteDetail.bartype3([data.factor['b02001']
      //               .value, data.factor['b02002'].value,
      //               res.result
      //                 .records[0].factor['b05001'].value
      //             ], [this.data2.title + '(' + this.data2.unitName +
      //             ')', this.data3.title + '(' + this.data3
      //               .unitName +
      //             ')', this.data4.title + '(' + this.data4
      //               .unitName + ')'
      //             ])
      //             this.$refs.siteDetail.bartypes([data.factor['b03001']
      //               .value, data.factor['b03003'].value,
      //               data.factor[
      //                 'b03004'].value, data.factor['b03002']
      //                 .value
      //             ], [this.data5.title + '(' + this.data5.unitName +
      //             ')', this.data6.title + '(' + this.data6
      //               .unitName +
      //             ')', this.data7.title + '(' + this.data7
      //               .unitName + ')', this.data8.title + '(' + this
      //               .data8.unitName +
      //             ')'
      //             ])
      //           } else {
      //             this.$refs.siteDetail.bartype2([0], [this.data1.title +
      //             '(' + this.data1.unitName + ')'
      //             ])
      //             this.$refs.siteDetail.bartype3([0, 0, 0], [this.data2
      //               .title + '(' + this.data2.unitName + ')', this
      //               .data3
      //               .title + '(' + this.data3.unitName + ')', this
      //               .data4.title + '(' + this.data4.unitName + ')'
      //             ])
      //             this.$refs.siteDetail.bartypes([0, 0, 0, 0], [this.data5
      //               .title + '(' + this.data5.unitName + ')', this
      //               .data6
      //               .title + '(' + this.data6.unitName + ')', this
      //               .data7.title + '(' + this.data7.unitName + ')',
      //               this.data8
      //                 .title + '(' + this.data8.unitName + ')'
      //             ])
      //           }
      //         })
      //       })
      //     }
      //   })
      // }

    },
    getSkyData: function getSkyData(id) {
      var _this12 = this;

      queryDateSkylist({
        scope: 1,
        scopeId: id,
        st: 22,
        column: 'data_time',
        // stime:this.getDay(0),
        // etime:this.getDay(0),
        order: 'desc' // type: 1

      }).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          if (res.result.records[0].attrs.pollutions.length > 0) {
            _this12.$refs.siteDetail.changeInstrument(res.result.records[0].attrs.pollutions[0].aqi, res.result.records[0].attrs.currentStandard.title, res.result.records[0].attrs.currentStandard.color);

            _this12.$refs.siteDetail.firstPollution = res.result.records[0].attrs.pollutions[0];
          } else {
            _this12.$refs.siteDetail.firstPollution = {};

            _this12.$refs.siteDetail.changeInstrument(0, '无', '#fff');
          }

          var obj = {};
          var arr = [];
          var title = [];
          res.result.query.factors.forEach(function (item, index) {
            // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
            if (res.result.records[0].factor[item.code] && res.result.records[0].factor[item.code].value != null) {
              arr.push(res.result.records[0].factor[item.code].value);
              title.push(item.title);
            }
          });

          if (arr.length > 6) {
            _this12.$refs.siteDetail.changeBartype(arr.slice(0, 6), title.slice(0, 6), 100);

            _this12.timer = setInterval(function () {
              arr.push(arr[0]); // 将数组的第一个元素添加到数组的

              arr.shift();
              title.push(title[0]); // 将数组的第一个元素添加到数组的

              title.shift();

              _this12.$refs.siteDetail.changeBartype(arr.slice(0, 6), title.slice(0, 6), 100);
            }, 2000);
          } else {
            _this12.$refs.siteDetail.changeBartype(arr, title, 100);
          }
        } else {
          if (res.result.query.factors.length > 0) {
            var _obj = {};
            var _arr = [];
            var _title = [];
            res.result.query.factors.forEach(function (item, index) {
              // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
              _arr.push(0);

              _title.push(item.title);
            });

            if (res.result.query.factors.length > 6) {
              _this12.$refs.siteDetail.changeBartype(_arr.slice(0, 6), _title.slice(0, 6), 100);

              _this12.timer = setInterval(function () {
                _arr.push(_arr[0]); // 将数组的第一个元素添加到数组的


                _arr.shift();

                _title.push(_title[0]); // 将数组的第一个元素添加到数组的


                _title.shift();

                _this12.$refs.siteDetail.changeBartype(_arr.slice(0, 6), _title.slice(0, 6), 100);
              }, 2000);
            } else {
              _this12.$refs.siteDetail.changeBartype(_arr, _title, 100);
            }
          } else {
            _this12.$refs.siteDetail.changeBartype([], [], 100);
          }

          _this12.$refs.siteDetail.changeInstrument(0, '无', '#fff');
        }
      });
    },
    getSkyJxData: function getSkyJxData(id) {
      var _this13 = this;

      getAction("/online/nchky/api/realtime/", {
        scope: 1,
        scopeId: id,
        st: 22,
        type: 1
      }).then(function (res) {
        if (res.success) {
          if (res.success && res.result.records.length > 0) {
            if (res.result.records[0].attrs.aqi) {
              _this13.$refs.siteDetail.changeInstrument(res.result.records[0].attrs.aqi.aqi, res.result.records[0].attrs.aqi.degree, res.result.records[0].attrs.aqi.color);

              _this13.$refs.siteDetail.firstPollution = res.result.records[0].attrs.aqi;
            } else {
              _this13.$refs.siteDetail.firstPollution = {};

              _this13.$refs.siteDetail.changeInstrument(0, '无', '#fff');
            }

            var obj = {};
            var arr = [];
            var title = [];
            res.result.query.factors.forEach(function (item, index) {
              // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
              if (res.result.records[0].factor[item.code] && res.result.records[0].factor[item.code].value != null) {
                arr.push(res.result.records[0].factor[item.code].value);
                title.push(item.title);
              }
            });

            if (arr.length > 6) {
              _this13.$refs.siteDetail.changeBartype(arr.slice(0, 6), title.slice(0, 6), 100);

              _this13.timer = setInterval(function () {
                arr.push(arr[0]); // 将数组的第一个元素添加到数组的

                arr.shift();
                title.push(title[0]); // 将数组的第一个元素添加到数组的

                title.shift();

                _this13.$refs.siteDetail.changeBartype(arr.slice(0, 6), title.slice(0, 6), 100);
              }, 2000);
            } else {
              _this13.$refs.siteDetail.changeBartype(arr, title, 100);
            }
          } else {
            if (res.result.query.factors.length > 0) {
              var _obj2 = {};
              var _arr2 = [];
              var _title2 = [];
              res.result.query.factors.forEach(function (item, index) {
                // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
                _arr2.push(0);

                _title2.push(item.title);
              });

              if (res.result.query.factors.length > 6) {
                _this13.$refs.siteDetail.changeBartype(_arr2.slice(0, 6), _title2.slice(0, 6), 100);

                _this13.timer = setInterval(function () {
                  _arr2.push(_arr2[0]); // 将数组的第一个元素添加到数组的


                  _arr2.shift();

                  _title2.push(_title2[0]); // 将数组的第一个元素添加到数组的


                  _title2.shift();

                  _this13.$refs.siteDetail.changeBartype(_arr2.slice(0, 6), _title2.slice(0, 6), 100);
                }, 2000);
              } else {
                _this13.$refs.siteDetail.changeBartype(_arr2, _title2, 100);
              }
            } else {
              _this13.$refs.siteDetail.changeBartype([], [], 100);
            }

            _this13.$refs.siteDetail.changeInstrument(0, '无', '#fff');
          }
        }
      });
    },
    getSkyRealTimeData: function getSkyRealTimeData(id) {
      var _this14 = this;

      queryDateSkyRealTime({
        scope: 1,
        scopeId: id,
        st: 22,
        column: 'data_time',
        // stime:this.getDay(0),
        // etime:this.getDay(0),
        order: 'desc' // type: 1

      }).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          var obj = {};
          var arr = [];
          var title = [];
          res.result.query.factors.forEach(function (item, index) {
            // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
            if (res.result.records[0].factor[item.code] && res.result.records[0].factor[item.code].value != null) {
              arr.push(res.result.records[0].factor[item.code].value);
              title.push(item.title);
            }
          });

          if (arr.length > 6) {
            _this14.$refs.siteDetail.changeBartype(arr.slice(0, 6), title.slice(0, 6), 100);

            _this14.timer = setInterval(function () {
              arr.push(arr[0]); // 将数组的第一个元素添加到数组的

              arr.shift();
              title.push(title[0]); // 将数组的第一个元素添加到数组的

              title.shift();

              _this14.$refs.siteDetail.changeBartype(arr.slice(0, 6), title.slice(0, 6), 100);
            }, 2000);
          } else {
            _this14.$refs.siteDetail.changeBartype(arr, title, 100);
          }
        } else {
          if (res.result.query.factors.length > 0) {
            var _obj3 = {};
            var _arr3 = [];
            var _title3 = [];
            res.result.query.factors.forEach(function (item, index) {
              // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
              _arr3.push(0);

              _title3.push(item.title);
            });

            if (res.result.query.factors.length > 6) {
              _this14.$refs.siteDetail.changeBartype(_arr3.slice(0, 6), _title3.slice(0, 6), 100);

              _this14.timer = setInterval(function () {
                _arr3.push(_arr3[0]); // 将数组的第一个元素添加到数组的


                _arr3.shift();

                _title3.push(_title3[0]); // 将数组的第一个元素添加到数组的


                _title3.shift();

                _this14.$refs.siteDetail.changeBartype(_arr3.slice(0, 6), _title3.slice(0, 6), 100);
              }, 2000);
            } else {
              _this14.$refs.siteDetail.changeBartype(_arr3, _title3, 100);
            }
          } else {
            _this14.$refs.siteDetail.changeBartype([], [], 100);
          } // this.$refs.siteDetail.changeInstrument(0, '无', '#fff')
          // this.$refs.siteDetail.changeBartype([], [], 500)

        }
      });
    },
    // 获取对应站点详情
    getStand: function getStand(data) {
      if (data) {
        for (var i = 0; i < this.standardList.length; i++) {
          if (this.standardList[i].data.title == data.title.replace('类', '')) {
            return i + 1;
          }
        }
      } else {
        return 0;
      }
    },
    // 获取国标数据
    getStandard: function getStandard() {
      var _this15 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          var arr = [];
          var arr1 = []; // if (st == '21') {

          _this15.standShape = 'map-tag-cir'; // } else if (st == '22') {

          _this15.standShape1 = 'map-tag-rec'; // }

          arr = [{
            title: '河',
            children: []
          }, {
            title: '湖',
            children: []
          }];
          arr1 = [{
            title: '气',
            children: []
          }];
          var arr2 = [{
            name: '',
            title: '',
            children: [{
              data: {
                show: true,
                color: 'green',
                id: 'true',
                icon: 'icon-feiqi',
                title: '达标'
              },
              title: '达标'
            }, {
              data: {
                show: true,
                color: 'red',
                id: 'false',
                icon: 'icon-feiqi',
                title: '不达标'
              },
              title: '不达标'
            }]
          }];
          var arr3 = [{
            name: '',
            title: '',
            children: [{
              data: {
                show: true,
                color: 'green',
                id: 'true',
                icon: 'icon-wushuifeishui',
                title: '达标'
              },
              title: '达标'
            }, {
              data: {
                show: true,
                color: 'red',
                id: 'false',
                icon: 'icon-wushuifeishui',
                title: '不达标'
              },
              title: '不达标'
            }]
          }];
          res.result.forEach(function (item, index) {
            if (item.label == '国家标准') {
              if (item.children != null) {
                item.children.forEach(function (item1, index1) {
                  if (item1.key == 'K1_3') {
                    arr[0].name = item1.title;
                    arr[0].children = item1.children;
                  }

                  if (item1.key == 'K1_4') {
                    arr[1].children = item1.children;
                    arr[1].name = item1.title;
                  }

                  if (item1.key == 'K1_2') {
                    arr1[0].children = item1.children;
                    arr1[0].name = item1.title;
                  }
                });
              }
            }
          });
          arr.forEach(function (item1, index) {
            item1.children.forEach(function (item) {
              item.data.title = item.data.title.replace('类', '');
              item.data.show = true;
            });
          });
          arr1.forEach(function (item2, index) {
            item2.children.forEach(function (item) {
              item.data.title = item.data.title.replace('类', '');
              item.data.show = true;
            });
          });
          _this15.standardList = arr;
          _this15.airStandardList = arr1;
          _this15.wasteStandardList = arr2;
          _this15.wasteAirStandardList = arr3;
        }
      });
    },
    // 抽取公共渲染标准的方法
    standType: function standType(res) {
      var color = [];
      var title = [];
      var a = [];
      var colors = ['green', 'red'];
      var date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res.result)[1]];

      if (res.result[date[0]] != null && res.result[date[0]].upStandard != null) {
        if (res.result[date[0]].upStandard == true) {
          color.push(colors[0]);
          title.push('达标');
          a.push(1);
        } else {
          color.push(colors[1]);
          title.push('不达标');
          a.push(2);
        }
      } else {
        color.push('');
        title.push('');
        a.push(0);
      }

      if (res.result[date[1]] != null && res.result[date[1]].upStandard != null) {
        if (res.result[date[1]].upStandard == true) {
          color.push(colors[0]);
          title.push('达标');
          a.push(1);
        } else {
          color.push(colors[1]);
          title.push('不达标');
          a.push(2);
        }
      } else {
        color.push('');
        title.push('');
        a.push(0);
      }

      if (res.result[date[2]] && res.result[date[2]].upStandard != null) {
        if (res.result[date[2]].upStandard == true) {
          color.push(colors[0]);
          title.push('达标');
          a.push(1);
        } else {
          color.push(colors[1]);
          title.push('不达标');
          a.push(2);
        }
      } else {
        color.push('');
        title.push('');
        a.push(0);
      }

      this.$refs.siteDetail.changeState(title, color, date, a, 2);
    },
    standFailtype: function standFailtype() {
      var _this16 = this;

      var date = new Date();
      var year1 = date.getFullYear() - 1 + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      var year2 = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      var year3 = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate();
      this.$nextTick(function () {
        _this16.$refs.siteDetail.changeState(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 2);
      });
    },
    // 获取实时水质标准
    getwaterStand: function getwaterStand(id, selectType) {
      var _this17 = this;

      if (selectType == 21) {
        getAction("/online/st".concat(selectType, "/standardBySite"), {
          scopeId: id,
          scope: 1
        }).then(function (res) {
          if (res.success) {
            var color = [];
            var title = [];
            var a = [];
            var date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res.result)[1]];
            a.push(_this17.getStand(res.result[date[0]] ? res.result[date[0]].currentStandard : ''));
            a.push(_this17.getStand(res.result[date[1]] ? res.result[date[1]].currentStandard : ''));
            a.push(_this17.getStand(res.result[date[2]] ? res.result[date[2]].currentStandard : ''));

            if (res.result[date[0]] != null && res.result[date[0]].currentStandard != null) {
              color.push(res.result[date[0]].currentStandard.color);
              title.push(res.result[date[0]].currentStandard.title);
            } else {
              color.push('');
              title.push('');
            }

            if (res.result[date[1]] != null && res.result[date[1]].currentStandard != null) {
              color.push(res.result[date[1]].currentStandard.color);
              title.push(res.result[date[1]].currentStandard.title);
            } else {
              color.push('');
              title.push('');
            }

            if (res.result[date[2]] != null && res.result[date[2]].currentStandard != null) {
              color.push(res.result[date[2]].currentStandard.color);
              title.push(res.result[date[2]].currentStandard.title);
            } else {
              color.push('');
              title.push('');
            }

            _this17.$refs.siteDetail.changeState(title, color, date, a, _this17.standardList.length); // this.$refs.dials.initBarChart(title, color, date, a, this.standardList.length)

          } else {
            var _date = new Date();

            var year1 = _date.getFullYear() - 1 + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

            var year2 = _date.getFullYear() + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

            var year3 = _date.getFullYear() + '-' + _date.getMonth() + '-' + _date.getDate();

            _this17.$refs.siteDetail.changeState(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 6); // this.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 6)

          }
        });
      } else if (selectType == 22) {
        querySkyPie({
          scope: 1,
          scopeId: id
        }).then(function (res) {
          if (res.success && res.result) {
            _this17.$refs.siteDetail.changePlate(res.result['excellent']); // this.$refs.siteDetail.changeDoubleplate(res.result['PM25'], res.result['pollution'])

          } else {
            _this17.$refs.siteDetail.changePlate({
              someNum: 0,
              nowNum: 0
            }); // this.$refs.siteDetail.changeDoubleplate({
            // 	someNum: 0,
            // 	nowNum: 0
            // }, {
            // 	someNum: 0,
            // 	nowNum: 0
            // })

          }
        }); // querySkyStandBySite('id=' + id).then((res) => {
        // 	if (res.success && res.result) {
        // 		this.$refs.siteDetail.changePlate(res.result['excellent'])
        // 		this.$refs.siteDetail.changeDoubleplate(res.result['PM25'], res.result['pollution'])
        // 	} else {
        // 		this.$refs.siteDetail.changePlate({
        // 			someNum: 0,
        // 			nowNum: 0
        // 		})
        // 		this.$refs.siteDetail.changeDoubleplate({
        // 			someNum: 0,
        // 			nowNum: 0
        // 		}, {
        // 			someNum: 0,
        // 			nowNum: 0
        // 		})
        // 	}
        // })
      }

      if (selectType.startsWith('3')) {
        getAction("/online/st".concat(selectType, "/standardBySite"), {
          scopeId: id,
          scope: 1
        }).then(function (res) {
          if (res.success) {
            _this17.standType(res);
          } else {
            _this17.standFailtype();
          }
        }); // queryWasteStand({
        // 	scopeId: id,
        // 	scope: 1
        // }).then((res) => {
        // 	if (res.success) {
        // 		this.standType(res)
        // 	} else {
        // 		this.standFailtype()
        // 	}
        // })
      } // else if(selectType == 31){
      // 	queryWastegasStand({
      // 		scopeId: id,
      // 		scope:1
      // 	}).then((res) => {
      // 		if (res.success && res.result) {
      // 			this.standType(res)
      // 		} else {
      // 			this.standFailtype()
      // 		}
      // 	})
      // }else if(selectType == 35){
      // 	queryWastesoilStand({
      // 		scopeId: id,
      // 		scope:1
      // 	}).then((res) => {
      // 		if (res.success && res.result) {
      // 			this.standType(res)
      // 		} else {
      // 			this.standFailtype()
      // 		}
      // 	})
      // }

    },
    initMarker: function initMarker() {
      var _this18 = this;

      var arr = [];
      map.remove(this.arr);
      map.remove(this.infoWindows);
      this.infoWindows = [];
      this.arr = [];
      this.markerList.forEach(function (item, index) {
        if (item.longitude && item.latitude && item.show) {
          var marker = new AMap.Marker({
            position: new AMap.LngLat(item.longitude, item.latitude),
            // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: item.name,
            offset: new AMap.Pixel(-20, -20),
            content: item.content,
            visible: item.show,
            zIndex: item.zIndex
          });

          if (_this18.showMarkerLabel) {
            marker.setLabel({
              content: item.name,
              direction: 'right',
              offset: new AMap.Pixel(-20, -25)
            });
          } // var infoWindow = new AMap.InfoWindow({
          // 	anchor: 'bottom-center',
          // 	retainWhenClose: false,
          // 	offset: new AMap.Pixel(-5, -20),
          // 	// content: this.$refs.pollution.$el, //传入 dom 对象，或者 html 字符串
          // 	content: this.$refs.siteDetail.$el, //传入 dom 对象，或者 html 字符串
          // })


          marker.on('click', function (data) {
            // this.$refs.siteDetail.fileState=false
            _this18.showContent = false;

            _this18.$nextTick(function () {
              _this18.showContent = true;

              _this18.$nextTick(function () {
                _this18.$refs.siteDetail.selectType = item.st;
                clearInterval(_this18.timer);

                _this18.getsiteDetail(item.id, item.st); // this.getwaterStand(item.id, item.st)


                _this18.$refs.pollution.initBarChart([], [], []);
              });
            }); // this.$refs.siteDetail.selectType = item.st
            // // map.setCenter([item.longitude, item.latitude])
            // // map.setCenter(new AMap.LngLat(item.longitude, item.latitude));
            // infoWindow.open(map, [item.longitude, item.latitude])

          });
          arr.push(marker);
          map.add(marker); // this.infoWindows.push(infoWindow)
        }
      });
      this.arr = arr;
    },
    initMap: function initMap() {
      var that = this;
      map = new AMap.Map('container', {
        center: that.center,
        // zoom: that.zoom,
        mapStyle: 'amap://styles/darkblue',
        // 极夜蓝
        pitch: 55,
        // zooms: [3, 15],
        buildingAnimation: true,
        viewMode: '3D'
      });
      map.setZoom(that.zoom);
      that.getSitearr(this.selectSt ? this.selectSt : undefined);
      map.plugin(['AMap.Autocomplete', 'AMap.PlaceSearch'], function () {
        var autoOptions = {
          datatype: 'all',
          input: 'keyword' //使用联想输入的input的id

        };
        var autocomplete = new AMap.Autocomplete(autoOptions);
        placeSearch = new AMap.PlaceSearch({
          map: map,
          pageSize: 1,
          extensions: 'all'
        });
        AMap.event.addListener(autocomplete, 'select', function (e) {
          //TODO 针对选中的poi实现自己的功能
          if (e.poi.location.lng != undefined) {
            map.setZoom(14);
            map.setCenter(new AMap.LngLat(e.poi.location.lng, e.poi.location.lat));
            that.state = true;
            that.location = new AMap.LngLat(e.poi.location.lng, e.poi.location.lat);
          } else {
            that.state = false;
            that.adcode = e.poi.adcode;
            that.adname = e.poi.name;
            placeSearch.setCity(e.poi.adcode);
            placeSearch.search(e.poi.name);
          }
        });
      });
      map.plugin(['AMap.MapType', 'AMap.MouseTool', 'AMap.ControlBar'], function () {
        //地图类型切换
        var type = new AMap.MapType({
          defaultType: 1 //使用2D地图

        });
        mouseTool = new AMap.MouseTool(map);
        map.addControl(type);
        map.addControl(new AMap.ControlBar({
          position: {
            bottom: '-20%',
            right: '20px'
          }
        }));
      });
      map.plugin(['AMap.RangingTool'], function () {
        rangingTool = new AMap.RangingTool(map);
        AMap.event.addListener(rangingTool, 'end', function (e) {
          rangingTool.turnOff();
        });
      }); // 添加叠加图层

      setMapTile(map);
      this.drawBounds();
    },
    positionSite: function positionSite(id) {
      var _this19 = this;

      this.markerList.forEach(function (v, i) {
        if (v.id == id) {
          _this19.center = v.position;
          _this19.zoom = 14;

          if (v.position[0] && v.position[1]) {
            map.setCenter(new AMap.LngLat(v.position[0], v.position[1]));
          }

          map.setZoom(14); // var infoWindow = new AMap.InfoWindow({
          // 	anchor: 'bottom-center',
          // 	retainWhenClose: false,
          // 	offset: new AMap.Pixel(-5, -20),
          // 	// content: this.$refs.pollution.$el, //传入 dom 对象，或者 html 字符串
          // 	content: this.$refs.siteDetail.$el, //传入 dom 对象，或者 html 字符串
          // })
          // this.infoWindows.push(infoWindow)
          // clearInterval(this.timer)
          // this.$refs.siteDetail.selectType = v.st
          // this.getsiteDetail(v.id)
          // this.getwaterStand(v.id, v.st)
          // this.getDateLists(v.id, v.st)
          // this.$refs.pollution.initBarChart([], [], [])

          _this19.showContent = false;

          _this19.$nextTick(function () {
            _this19.showContent = true;

            _this19.$nextTick(function () {
              clearInterval(_this19.timer);
              _this19.$refs.siteDetail.selectType = v.st;

              _this19.getsiteDetail(v.id, v.st); // this.getwaterStand(v.id, v.st)
              // this.getDateLists(v.id, v.st)


              _this19.$refs.pollution.initBarChart([], [], []);
            });
          }); // map.setCenter(new AMap.LngLat(item.longitude, item.latitude));
          // infoWindow.open(map, [v.longitude, v.latitude])

        }
      });
    }
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();

      if (ids[0] && ids[0] == 1) {
        // 根据站点id
        this.positionSite(ids[1]);
      } else {
        if (ids[0] && ids[1]) {
          if (ids[0] != 5) {
            this.drawBounds(ids[1]);
          } else {// 点击管网查询管网数据并定位到对应位置
          }
        } // 根据区域id
        // if (ids[1] == 57) {
        //   //是否选择了雅安市
        //   this.center = [103.003398, 29.981831]
        //   this.zoom = 9
        // } else {
        // }

      }
    },
    selectSt: function selectSt(value) {
      if (value) {
        this.st = value;
      } else {
        this.st = '';
      }

      console.log(value);

      if (this.firstState) {
        this.getSitearr(value);
      }

      this.firstState = true;
    }
  }
};